/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Guide_S6_TitleInputs */

const en_landing_guide_s6_title = /** @type {(inputs: Landing_Guide_S6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Using Ideogram AI 4.5 on ideogram-45.com`)
};

const zh_landing_guide_s6_title = /** @type {(inputs: Landing_Guide_S6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在 ideogram-45.com 使用 Ideogram AI 4.5`)
};

/**
* | output |
* | --- |
* | "Using Ideogram AI 4.5 on ideogram-45.com" |
*
* @param {Landing_Guide_S6_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_guide_s6_title = /** @type {((inputs?: Landing_Guide_S6_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Guide_S6_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_guide_s6_title(inputs)
	return zh_landing_guide_s6_title(inputs)
});
export { landing_guide_s6_title as "landing.guide.s6_title" }